// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".in-modal header>div{background:#172203!important;opacity:1%}@media (max-width:1023px){.imgs{height:320px!important;width:100%!important;margin-top:0!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
